import { $ } from '../../../src/Framework';
import { Component } from '../../../src/Component';
import BS_Carousel from 'bootstrap/js/dist/carousel';
export class Carousel extends Component {
    constructor() {
        super('Carousel', true);
    }
    async init() {
        await super.init();
        $('.carousel').forEach((carousel) => {
            new BS_Carousel(carousel);
            // here you can add events or whatever
        });
        this.success();
    }
}
